var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          _vm.form.get(_vm.route("help-articles.index"))
        },
      },
    },
    [
      _c("v-text-field", {
        staticStyle: { "border-radius": "36px !important" },
        attrs: {
          autofocus: "",
          rounded: "",
          solo: "",
          height: "64",
          label: "What do you need help with?",
          placeholder: "What do you need help with?",
          name: "s",
          "append-icon": "search",
          "hide-details": "",
        },
        model: {
          value: _vm.form.s,
          callback: function ($$v) {
            _vm.$set(_vm.form, "s", $$v)
          },
          expression: "form.s",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }